export default __webpack_public_path__ + "static/media/35t_van.f5aacb0c.svg";